import { on } from "@ngrx/store";
import { SuperUserState } from "../super-user.state";
import { CountriesActions } from "./countries.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update superUser state within PagesStore
// **************************************************************************

function withSuperUser(state: PagesStore, updater: (superUser: SuperUserState) => SuperUserState): PagesStore {
    return { ...state, superUser: updater(state.superUser) };
}

// **************************************************************************
// COUNTRIES REDUCER (array format for PagesStore)
// **************************************************************************

const load = on(CountriesActions.load, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: { ...superUserState.countries, error: null },
})));

const loadSuccess = on(CountriesActions.loadSuccess, (state: PagesStore, { countries }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: {
        ...superUserState.countries,
        countries,
        loaded: true,
        error: null,
    },
})));

const invalidate = on(CountriesActions.invalidate, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: { ...superUserState.countries, loaded: false },
})));

const loadFailure = on(CountriesActions.loadFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: { ...superUserState.countries, error },
})));

// Project Management
const createCountryProjectManagement = on(CountriesActions.createCountryProjectManagement, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: {
        ...superUserState.countries,
        loading: { ...superUserState.countries.loading, projectManagementSaving: true },
        error: null,
    },
})));

const createCountryProjectManagementSuccess = on(CountriesActions.createCountryProjectManagementSuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: {
        ...superUserState.countries,
        loading: { ...superUserState.countries.loading, projectManagementSaving: false },
        error: null,
    },
})));

const createCountryProjectManagementFailure = on(CountriesActions.createCountryProjectManagementFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: {
        ...superUserState.countries,
        loading: { ...superUserState.countries.loading, projectManagementSaving: false },
        error,
    },
})));

const updateCountryProjectManagement = on(CountriesActions.updateCountryProjectManagement, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: {
        ...superUserState.countries,
        loading: { ...superUserState.countries.loading, projectManagementSaving: true },
        error: null,
    },
})));

const updateCountryProjectManagementSuccess = on(CountriesActions.updateCountryProjectManagementSuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: {
        ...superUserState.countries,
        loading: { ...superUserState.countries.loading, projectManagementSaving: false },
        error: null,
    },
})));

const updateCountryProjectManagementFailure = on(CountriesActions.updateCountryProjectManagementFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: {
        ...superUserState.countries,
        loading: { ...superUserState.countries.loading, projectManagementSaving: false },
        error,
    },
})));

const deleteCountryProjectManagement = on(CountriesActions.deleteCountryProjectManagement, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: {
        ...superUserState.countries,
        loading: { ...superUserState.countries.loading, projectManagementSaving: true },
        error: null,
    },
})));

const deleteCountryProjectManagementSuccess = on(CountriesActions.deleteCountryProjectManagementSuccess, (state: PagesStore) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: {
        ...superUserState.countries,
        loading: { ...superUserState.countries.loading, projectManagementSaving: false },
        error: null,
    },
})));

const deleteCountryProjectManagementFailure = on(CountriesActions.deleteCountryProjectManagementFailure, (state: PagesStore, { error }) => withSuperUser(state, superUserState => ({
    ...superUserState,
    countries: {
        ...superUserState.countries,
        loading: { ...superUserState.countries.loading, projectManagementSaving: false },
        error,
    },
})));

export const countriesReducer = [
    invalidate,
    load,
    loadSuccess,
    loadFailure,
    createCountryProjectManagement,
    createCountryProjectManagementSuccess,
    createCountryProjectManagementFailure,
    updateCountryProjectManagement,
    updateCountryProjectManagementSuccess,
    updateCountryProjectManagementFailure,
    deleteCountryProjectManagement,
    deleteCountryProjectManagementSuccess,
    deleteCountryProjectManagementFailure,
];
